import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStore } from './auth.store';

export const authGuard: CanActivateFn = () => {
	const platformId = inject(PLATFORM_ID);
	const authStore = inject(AuthStore);
	const router = inject(Router);

	if (!isPlatformBrowser(platformId)) return true;

	if (authStore.isAuthenticated()) return true;

	return router.createUrlTree(['/auth/login']);
};
